import { render } from "./SectionAbout.vue?vue&type=template&id=420cefc6"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__